<template>
  <div v-show="loading" class="spinner spin">
    <DSIcon class="icon">deputy</DSIcon>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '#5dc596',
    },
    size: {
      type: String,
      default: '15px',
    },
    margin: {
      type: String,
      default: '2rem',
    },
    radius: {
      type: String,
      default: '100%',
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.icon {
  padding: 1rem;
  padding-bottom: 8px;
}
.spinner {
  font-size: 3rem;
  color: #1a92da;
  padding: 2rem;
}
.spin {
  -webkit-animation: spin 1.5s infinite linear;
  animation: spin 1.5s infinite linear;
}
/* Google Chrome, Safari, Android Browser */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
/* Opera */
@-o-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
/* Internet Explorer, Edge */
@-ms-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
/* Mozilla Firefox */
@-moz-keyframes spin {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
